/*
包含n个用于间接更新状态的方法的对象模块
 */
import {ON_HTTP_ERROR,  SAVE_USER_INFO, CURR_AREA_CODE,TOMCAT_INFO} from './mutation-types'

export default {

  [ON_HTTP_ERROR]({commit}, searchName) {
    // 提交mutation
    commit(ON_HTTP_ERROR, searchName)
  },
  [SAVE_USER_INFO]({commit}, userInfo) {
    // 提交mutation
    commit(SAVE_USER_INFO, userInfo)
  },
  [CURR_AREA_CODE]({commit},currAreaCode) {
    // 提交mutation
    commit(CURR_AREA_CODE, currAreaCode)
  },
  [TOMCAT_INFO]({commit},tomcatInfo) {
    // 提交mutation
    commit(TOMCAT_INFO, tomcatInfo)
  },
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js